export const TOGGLE_YEARLY_PRICING = 'TOGGLE_YEARLY_PRICING';

export function toggleYearlyPricing(yearlyPricing){
    return{
        type: TOGGLE_YEARLY_PRICING,
        mainState: {
            yearlyPricing: yearlyPricing
        }
    }
}